import React from 'react';
import { useScopedI18n } from '@locales/client';
import { useRouter,usePathname } from 'next/navigation';
import { Button } from '@/shared/ui/form/button/button';
import {
  HeadingMediumH5,
  BodyTextRegularC,
  BodyTextRegularB
} from '@/shared/ui/typography2';
import { Image } from '@/shared/ui/image/Image';
import { useIsMult } from '@/shared/providers/user-provider/use-user';

import * as Dialog from '@radix-ui/react-dialog';
import { StyledAlertDialogOverlay } from '@/shared/ui/alert-dialog/styles';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import {
  StyledMultDialogContent,
  Navigation,
  CloseButton,
  InfoContainer,
  Details,
  ButtonsContainer
} from './styles';
import { createDialogCloseOnlyHandler } from '@/shared/libs/dialog-open-change';

export const MultiAccountWarningModal = () => {
  const isMult = useIsMult();
  const t = useScopedI18n('multi_account_modal');
  const router = useRouter();
  const pathname = usePathname();
  const isBonusesPage = pathname.includes('bonuses');

  const handleClose = () => {
    router.push('/');
  };

  const handleConfirmDeposit = () => {
    sessionStorage.setItem('welcomeBonus', JSON.stringify(true));
    router.push('/');
  };

  const keyForLoc = isBonusesPage ? 'bonus' : 'cashback';

  return (
    <Dialog.Root open={isMult} onOpenChange={createDialogCloseOnlyHandler(handleClose)}>
      <Dialog.Portal>
        <StyledAlertDialogOverlay />
        
        <StyledMultDialogContent aria-describedby="" data-item="multi_account_warning">
          <VisuallyHidden>
            <Dialog.Title>{t('common.title')}</Dialog.Title>
          </VisuallyHidden>

          <Navigation>
            <CloseButton onClick={handleClose}>
              <Image
                src="/images/icons/close-dialog.svg"
                width={32}
                height={32}
                alt={t('common.buttons.close')}
              />
            </CloseButton>
          </Navigation>

          <Details $textAlign='center'>
              <HeadingMediumH5>{t('common.title')}</HeadingMediumH5>
              <BodyTextRegularB>{t(`${keyForLoc}.subtitle`)}</BodyTextRegularB>
            </Details>
          <InfoContainer>
            
            <Details>
              <BodyTextRegularC>
                {t('common.descriptions.system_detected')}
              </BodyTextRegularC>
            </Details>
            
            <Details>
              <BodyTextRegularC>
                {t(`${keyForLoc}.blocked_reason`)}
              </BodyTextRegularC>
              <BodyTextRegularC>
                {t('common.descriptions.means_multiple_accounts')}
              </BodyTextRegularC>
              <BodyTextRegularC>
                {t('common.descriptions.unlock_by_deposit')}
              </BodyTextRegularC>
              <BodyTextRegularC>
                {t('common.descriptions.contact_for_questions', {
                  email: t('common.email')
                })}
              </BodyTextRegularC>
            </Details>
          </InfoContainer>

          <ButtonsContainer>
            <Button
              type="button"
              onClick={handleConfirmDeposit}
              variant="orangeGradient"
              data-analytics-id="multi_account_warning_deposit"
            >
              <BodyTextRegularB>{t('common.buttons.deposit')}</BodyTextRegularB>
            </Button>
            <Button
              type="button"
              onClick={handleClose}
              variant="gray"
            >
              <BodyTextRegularB>{t('common.buttons.close')}</BodyTextRegularB>
            </Button>
          </ButtonsContainer>
        </StyledMultDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};